module.exports = __webpack_public_path__ + "static/media/AwsDoc6.30b6c61e.png";